module.exports = __webpack_public_path__ + "static/media/20ECE6.9b1a7d30.jpg";